import { gql } from '@apollo/client';

export const FETCH_STOCKS_INTRADAY_HISTORY = gql`
  query fetchStocksIntradayHistory {
    intradayHistory(filter: { type: Stocks }) {
      id
      symbol
      price
      volume
      value
      date
    }
  }
`;
